module.exports = {
	"de": {
		"copyright": "Alle Rechte vorbehalten",
		"imprint": "Impressum / AGB",
		"contact": {
			"title": "Kontaktieren Sie uns",
			"tagline": "Schreiben Sie uns eine E-Mail und wir kommen auf Sie zurück.",
			"button": "Schreiben"
		}
	},
	"en": {
		"copyright": "All Rights Reserved",
		"imprint": "Imprint",
		"contact": {
			"title": "Get In Touch",
			"tagline": "Need something? Write us an email and we'll get back to you.",
			"button": "Contact Us"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/footer/locales.json
// module id = 62
// module chunks = 0